/* Imagine Creation — Subheader: ซ่อน/แสดงตามทิศการเลื่อน · ขอบจาง · สลับเรื่องเด่น */
(function () {
  if (window.__icSub) return;
  window.__icSub = true;
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var bar = null, hidden = false, lastY = 0, ticking = false, timer = 0;

  function setVar() { root.style.setProperty('--ic-sub-h', bar && !hidden ? bar.offsetHeight + 'px' : '0px'); }
  function show(on) {
    if (!bar || hidden === !on) return;
    hidden = !on;
    bar.classList.toggle('is-hidden', hidden);
    setVar();
  }
  function onScroll() {
    if (ticking || !bar) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      var y = window.pageYOffset || root.scrollTop;
      var d = y - lastY;
      if (y < 120) show(true);
      else if (d > 8) show(false);
      else if (d < -8) show(true);
      if (Math.abs(d) > 8) lastY = y;
    });
  }
  function edges(sc) {
    bar.toggleAttribute('data-ov-l', sc.scrollLeft > 4);
    bar.toggleAttribute('data-ov-r', sc.scrollLeft + sc.clientWidth < sc.scrollWidth - 4);
  }
  function init() {
    var b = document.querySelector('[data-ic-sub]');
    if (!b || b.__init) return;
    b.__init = true;
    bar = b; hidden = false; lastY = window.pageYOffset || 0;
    setVar();
    var sc = bar.querySelector('[data-sub-scroll]');
    if (sc) {
      sc.addEventListener('scroll', function () { edges(sc); }, { passive: true });
      edges(sc);
    }
    /* เรื่องเด่นหลายเรื่อง: สลับทุก N วินาที (หยุดเมื่อชี้/โฟกัส) */
    clearInterval(timer);
    var box = bar.querySelector('[data-sub-rot]');
    var fts = box ? Array.prototype.slice.call(box.querySelectorAll('[data-sub-ft]')) : [];
    if (fts.length) fts[0].classList.add('is-on');
    if (fts.length > 1) {
      box.classList.add('is-rot');
      var i = 0, pause = false;
      box.addEventListener('mouseenter', function () { pause = true; });
      box.addEventListener('mouseleave', function () { pause = false; });
      box.addEventListener('focusin', function () { pause = true; });
      box.addEventListener('focusout', function () { pause = false; });
      timer = setInterval(function () {
        if (pause || hidden || document.hidden) return;
        fts[i].classList.remove('is-on');
        i = (i + 1) % fts.length;
        fts[i].classList.add('is-on');
      }, Math.max(3000, +box.getAttribute('data-interval') || 6000));
    }
  }
  window.addEventListener('scroll', function () { if (bar && bar.getAttribute('data-hide') === 'true') onScroll(); }, { passive: true });
  window.addEventListener('resize', function () {
    if (!bar) return;
    setVar();
    var sc = bar.querySelector('[data-sub-scroll]');
    if (sc) edges(sc);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () { bar = null; init(); });
  /* เลือก block ใน Theme editor → แสดงเรื่องเด่นนั้น */
  document.addEventListener('shopify:block:select', function (e) {
    var ft = e.target && e.target.closest ? e.target.closest('[data-sub-ft]') : null;
    if (!ft) return;
    show(true);
    Array.prototype.forEach.call(ft.parentNode.children, function (x) { x.classList.toggle('is-on', x === ft); });
  });
  if (reduce) root.classList.add('ic-sub-reduce');
})();
